import React, { PropsWithChildren } from 'react';
import styles from './dictionary-components.module.scss';

export default function AkFatBlack({ children }: PropsWithChildren<{}>) {
    return <span className={styles.wwiseAkFatBlack}>{children}</span>;
}
